import { render } from "./AvatartType1.vue?vue&type=template&id=d1fd202c&scoped=true"
import script from "./AvatartType1.vue?vue&type=script&lang=js"
export * from "./AvatartType1.vue?vue&type=script&lang=js"

import "./AvatartType1.vue?vue&type=style&index=0&id=d1fd202c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fd202c"]])

export default __exports__